import { createRef } from 'react';

import type { DropdownOptionWithRef } from '~/components/Dropdown/contexts/DropdownContext.tsx';
import type { DropdownOption } from '~/components/Dropdown/types/DropdownOption';

export function createCollection<T extends string>(
  options: DropdownOption<T>[],
): DropdownOptionWithRef<T>[] {
  return options.map((item) => {
    return {
      ...item,
      ref: createRef() as React.RefObject<HTMLDivElement> | null,
    };
  });
}
